import { Box, CircularProgress } from '@material-ui/core';
import React from 'react';

export default function SectionLoader(props) {
    return <Box display='flex' justifyContent='center' alignItems={`center`} flexDirection='column' flex={1}>
        <CircularProgress color='secondary' />
    </Box>
} 